var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"icon-svg",style:({ fontSize: _vm.size + 'px', color: _vm.color }),attrs:{"aria-label":_vm.icon,"role":"img"}},_vm.$listeners),[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.icon}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }